// src/components/panel/getdolar.js
import axios from 'axios';
import { DollarOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { useState, useEffect } from 'react';

function GetDolar() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`https://dolarapi.com/v1/dolares/oficial`)
            .then(res => {
                setData(res.data);
                setLoading(false);
            })
            .catch(er => {
                console.error("Error fetching dolar data:", er);
                setError("Error al cargar la cotización del dólar.");
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className='card'>
                <div className='card-content-center'>
                    <Spin tip="Cargando cotización..." />
                </div>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className='card'>
                <div className='card-content-center' style={{ color: '#ff4d4f' }}>
                    {error || 'No se pudo cargar la cotización.'}
                </div>
            </div>
        );
    }

    const formattedDate = data.fechaActualizacion ? new Date(data.fechaActualizacion).toLocaleString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }) : 'Fecha no disponible';

    return (
        <div className='card'>
            <div className='card-inner'>
                <DollarOutlined className='card_icon' style={{ fontSize: '38px' }} />
                <h2>DOLAR OFICIAL</h2>
            </div>
            <br />
            <div className='dashboard-card-content'>
                <div className='dollar-main-value'>
                    <h1 style={{ color: '#0F9D58' }}>${data.venta?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</h1>
                    <p className='dollar-subtitle'>Precio de venta</p>
                </div>
                
                <div className='sales-comparison'>
                    <div className='comparison-row'>
                        <span>Compra:</span>
                        <span className='comparison-value'>${data.compra?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                    </div>
                    <div className='comparison-row' style={{ color: '#8c8c8c' }}>
                        <span style={{ fontSize: '0.85rem' }}>Actualizado:</span>
                        <span style={{ fontSize: '0.85rem' }}>{formattedDate}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GetDolar;